import { render, staticRenderFns } from "./attrValueList.vue?vue&type=template&id=34732b6a&scoped=true"
import script from "./attrValueList.vue?vue&type=script&lang=js"
export * from "./attrValueList.vue?vue&type=script&lang=js"
import style0 from "./attrValueList.vue?vue&type=style&index=0&id=34732b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34732b6a",
  null
  
)

export default component.exports